/**
 * @file messages.tsx
 *
 * @fileoverview Custom hook to register messages in the global context.
 */

import { FlagMessage } from '~/jobiqo/models/app';
import { useStore } from '~/jobiqo/context/state';

export interface FlagDispatchEvent {
  type: 'addFlag' | 'removeFlag';
  message: FlagMessage;
}

export interface FlagsService {
  flags: FlagMessage[];
  addFlag: (message: FlagMessage) => void;
  removeFlag: (message: FlagMessage) => void;
}
export const useFlags = (): FlagsService => {
  const { state, dispatch } = useStore();
  const stateFlags: FlagMessage[] = state && state.flags ? state.flags : [];
  return {
    flags: stateFlags,
    addFlag: (flag: FlagMessage) => {
      dispatch({ type: 'addFlag', flag });
    },
    removeFlag: (flag: FlagMessage) => {
      dispatch({ type: 'removeFlag', flag });
    },
  };
};
